module.exports = __webpack_public_path__ + "static/img/guan.3307bb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guan.png
// module id = P5/Y
// module chunks = 36